import React from "react";
import GenericCrudPage from "./GenericCrudPage";
import { Badge } from "@/components/ui/badge";
import { Bell, AlertTriangle, CheckCircle2, Archive } from "lucide-react";

const NOTICE_STATUS = ["Draft","Published","Expired","Archived"];
const PRIORITY = ["Normal","Important","Urgent"];
const CATEGORIES = ["Operasional","Cuaca","SOP","Prosedur","Sistem","Regulasi","Lainnya"];

const priBadge = (p) => {
  if (p === "Urgent") return <Badge className="bg-red-600 text-white animate-pulse">URGENT</Badge>;
  if (p === "Important") return <Badge className="bg-amber-100 text-amber-800">IMPORTANT</Badge>;
  return <Badge className="bg-slate-100 text-slate-700">NORMAL</Badge>;
};
const stBadge = (s) => {
  const m = { Draft:"bg-slate-100 text-slate-700", Published:"bg-emerald-100 text-emerald-700", Expired:"bg-red-100 text-red-700", Archived:"bg-slate-200 text-slate-700" };
  return <Badge className={m[s] || m.Draft}>{s}</Badge>;
};

const noticeFields = () => ([
  { key: "notice_number", label: "Nomor", mono: true },
  { key: "priority", label: "Prioritas", type: "select", options: PRIORITY, badge: priBadge },
  { key: "title", label: "Judul", colSpan: 2 },
  { key: "category", label: "Kategori", type: "select", options: CATEGORIES },
  { key: "status", label: "Status", type: "select", options: NOTICE_STATUS, badge: stBadge },
  { key: "published_date", label: "Tgl Terbit", type: "date" },
  { key: "effective_date", label: "Tgl Efektif", type: "date" },
  { key: "expiry_date", label: "Tgl Berakhir", type: "date" },
  { key: "published_by", label: "Diterbitkan Oleh" },
  { key: "attachment", label: "Lampiran", type: "file", colSpan: 2, hideInTable: true },
  { key: "description", label: "Deskripsi", type: "textarea", colSpan: 2, hideInTable: true },
]);

const summary = [
  { label: "Total", icon: Bell, tone:"bg-slate-100 text-slate-700", compute:(d)=>d.length },
  { label: "Published", icon: CheckCircle2, tone:"bg-emerald-100 text-emerald-700", compute:(d)=>d.filter(x=>x.status==="Published").length },
  { label: "Urgent", icon: AlertTriangle, tone:"bg-red-100 text-red-700", compute:(d)=>d.filter(x=>x.priority==="Urgent").length },
  { label: "Draft/Archive", icon: Archive, tone:"bg-amber-100 text-amber-700", compute:(d)=>d.filter(x=>x.status==="Draft"||x.status==="Archived").length },
];

const searchKeys = ["notice_number","title","category"];
const filterFields = [{ key:"status", label:"Status", options: NOTICE_STATUS }, { key:"priority", label:"Prioritas", options: PRIORITY }];

const defaultNotice = { notice_number:"", title:"", category: CATEGORIES[0], description:"", published_date:"", effective_date:"", expiry_date:"", priority:"Normal", published_by:"", status:"Draft", attachment:null };

export function OFNoticePage() {
  return <GenericCrudPage resource="notice/of" title="OF Notice" subtitle="Operational Flight"
    moduleKey="notice_of" testidPrefix="of-notice" fields={noticeFields()} defaultItem={defaultNotice}
    searchKeys={searchKeys} filterFields={filterFields} summaryCards={summary}/>;
}
export function OFCNoticePage() {
  return <GenericCrudPage resource="notice/ofc" title="OFC Notice" subtitle="Operational Flight Control"
    moduleKey="notice_ofc" testidPrefix="ofc-notice" fields={noticeFields()} defaultItem={defaultNotice}
    searchKeys={searchKeys} filterFields={filterFields} summaryCards={summary}/>;
}

const INFO_STATUS = ["Draft","Published","Archived"];
const INFO_CAT = ["HR","Training","Info","Kebijakan","Kegiatan","Lainnya"];
const infoStBadge = (s) => stBadge(s);

const infoFields = () => ([
  { key: "title", label: "Judul", colSpan: 2 },
  { key: "category", label: "Kategori", type: "select", options: INFO_CAT },
  { key: "date", label: "Tanggal", type: "date" },
  { key: "status", label: "Status", type: "select", options: INFO_STATUS, badge: infoStBadge },
  { key: "published_by", label: "Diterbitkan Oleh" },
  { key: "attachment", label: "Lampiran", type: "file", colSpan: 2, hideInTable: true },
  { key: "description", label: "Deskripsi", type: "textarea", colSpan: 2, hideInTable: true },
]);
const infoSummary = [
  { label:"Total", icon:Bell, tone:"bg-slate-100 text-slate-700", compute:(d)=>d.length },
  { label:"Published", icon:CheckCircle2, tone:"bg-emerald-100 text-emerald-700", compute:(d)=>d.filter(x=>x.status==="Published").length },
  { label:"Draft", icon:Archive, tone:"bg-amber-100 text-amber-700", compute:(d)=>d.filter(x=>x.status==="Draft").length },
  { label:"Archived", icon:Archive, tone:"bg-slate-200 text-slate-700", compute:(d)=>d.filter(x=>x.status==="Archived").length },
];
const defaultInfo = { title:"", category: INFO_CAT[0], description:"", date:"", published_by:"", status:"Draft", attachment:null };

export function OFInfoPage() {
  return <GenericCrudPage resource="info/of" title="OF Info" subtitle="Operational Flight"
    moduleKey="info_of" testidPrefix="of-info" fields={infoFields()} defaultItem={defaultInfo}
    searchKeys={["title","category"]} filterFields={[{key:"status",label:"Status",options:INFO_STATUS},{key:"category",label:"Kategori",options:INFO_CAT}]} summaryCards={infoSummary}/>;
}
export function OFAInfoPage() {
  return <GenericCrudPage resource="info/ofa" title="OFA Info" subtitle="Operational Flight A"
    moduleKey="info_ofa" testidPrefix="ofa-info" fields={infoFields()} defaultItem={defaultInfo}
    searchKeys={["title","category"]} filterFields={[{key:"status",label:"Status",options:INFO_STATUS},{key:"category",label:"Kategori",options:INFO_CAT}]} summaryCards={infoSummary}/>;
}
export function OFBInfoPage() {
  return <GenericCrudPage resource="info/ofb" title="OFB Info" subtitle="Operational Flight B"
    moduleKey="info_ofb" testidPrefix="ofb-info" fields={infoFields()} defaultItem={defaultInfo}
    searchKeys={["title","category"]} filterFields={[{key:"status",label:"Status",options:INFO_STATUS},{key:"category",label:"Kategori",options:INFO_CAT}]} summaryCards={infoSummary}/>;
}
export function OFCInfoPage() {
  return <GenericCrudPage resource="info/ofc" title="OFC Info" subtitle="Operational Flight Control"
    moduleKey="info_ofc" testidPrefix="ofc-info" fields={infoFields()} defaultItem={defaultInfo}
    searchKeys={["title","category"]} filterFields={[{key:"status",label:"Status",options:INFO_STATUS},{key:"category",label:"Kategori",options:INFO_CAT}]} summaryCards={infoSummary}/>;
}
export function OFTInfoPage() {
  return <GenericCrudPage resource="info/oft" title="OFT Info" subtitle="Operational Flight Training"
    moduleKey="info_oft" testidPrefix="oft-info" fields={infoFields()} defaultItem={defaultInfo}
    searchKeys={["title","category"]} filterFields={[{key:"status",label:"Status",options:INFO_STATUS},{key:"category",label:"Kategori",options:INFO_CAT}]} summaryCards={infoSummary}/>;
}
